import { isValidPhoneNumber, parsePhoneNumber } from 'react-phone-number-input';
import type { Country } from 'react-phone-number-input';

export const isPhoneNumberValid = (value: string | undefined): boolean => (value ? isValidPhoneNumber(value) : false);

export const stripCountryCode = (value: string | undefined): string =>
  value ? (parsePhoneNumber(value)?.nationalNumber ?? value) : '';

export const toE164 = (nationalNumber: string | undefined, country: Country = 'CA'): string =>
  nationalNumber ? (parsePhoneNumber(nationalNumber, country)?.format('E.164') ?? nationalNumber) : '';
